<template>
    <span>
          <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                   <v-btn dark fab x-small color="blue darken-3" @click="exportDialog=true" v-on="on">
                 <v-icon dark>mdi mdi-file-export</v-icon>
             </v-btn>
             </template>
      <span>Export to excel</span>
    </v-tooltip>

                <v-dialog persistent v-model="exportDialog" width="500" transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="blue darken-3">
                    <v-toolbar-title>Export Options</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pa-2">
                    <v-container grid-list-md>
                        <v-layout wrap row>
                            <v-flex xs12>
                                <v-text-field label="Name of export" v-model="exportName" outlined
                                              type="text"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                        label="Number of rows to export"
                                        v-model="exportRows"
                                        outlined
                                        :disabled="exportRows ==='all'"
                                        type="number"
                                        onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"

                                />
                            </v-flex>
                            <!--                            <v-flex xs12 class="py-0">-->
                            <!--                                <v-checkbox v-model="exportRows" label="Export All" value="all"></v-checkbox>-->
                            <!--                            </v-flex>-->
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="red lighten-1"
                            :disabled="loading"
                            class="white--text"
                            @click="closeDialog "
                    >Cancel
                    </v-btn>
                    <v-btn color="blue darken-3" :loading="loading" class="white--text" @click="exportExcel">Export
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>

</template>

<script>
    import Http from 'axios'

    export default {
        name: 'ExportExcelButton',
        props: ['exportData'],
        data() {
            return {
                exportDialog: false,
                loading: false,
                exportRows: 10,
                exportName: 'export_name'
            };
        },
        methods: {
            closeDialog() {
                this.exportDialog = false;
                // this.exportRows = null;
                this.exportName = '';
            },
            exportExcel() {
                this.loading = true;
                this.exportData({
                    rows: this.exportRows,
                    name: this.exportName
                }).then(() => {
                    this.loading = false;
                    this.closeDialog()
                    this.$store.commit('Notification/showSuccess', 'Data exported successfully')
                }).catch(() =>{
                    this.loading = false;
                    this.$store.commit('Notification/showError', 'Something went wrong')

                })
            }
        }
    }
</script>
